module.exports = __webpack_public_path__ + "img/amex.14142ef4.svg";